import { Row, Col, Card } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import classes from "./Dashboard.module.css";
// import { FaHandsHelping, FaFileInvoice, FaReceipt } from "react-icons/fa";
// import { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
// import { GiSellCard } from "react-icons/gi";
// import DataContext from "../../../Context/dataContext";
const DataCards = (props) => {
  // // console.log(props.employeeData.analysis);

  // // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  return (
    <Row>
      <Col
        lg={{ span: 11, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            backgroundColor: "#daebf336",
            // border: "2px solid red",
          }}
          bordered={true}
          className={classes["Card"]}
        >
          {/* Row 1: Add New Contract */}
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/stock/transaction/requisition-create?requisition"
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add New Requisation
                </span>
              </Link>
            </Col>
          </Row>

          {/* Row 2: Total Contract Monthly */}
          <Row>
            {/* Text Column */}
            <Col
              lg={18}
              md={16}
              xs={14}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#45b6fe",
                  fontSize: "16px",
                  fontWeight: 600,
                  whiteSpace: "nowrap", // Prevents text from wrapping
                }}
              >
                Month To Date Requisation
              </span>
            </Col>

            {/* Number Column */}
            <Col
              lg={6}
              md={8}
              xs={10}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns number to the right
                alignItems: "center",
              }}
            >
              <div className={classes["Rata1"]} style={{ textAlign: "right" }}>
                {props.data.TotalSaudaMonthlyValue ?? null}
              </div>
            </Col>
          </Row>

          {/* Row 3: Total Contract Yearly */}
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "16px", fontWeight: 600 }}
              >
                Year To Date Requisation
              </span>
              <div className={classes["Rata1"]}>
                {props.data.TotalSaudaYearlyValue ?? null}
              </div>
            </Col>
          </Row>

          {/* Row 4: Pending Contract */}
          <Row>
            <Col
              span={17}
              style={{
                display: "flex",
                justifyContent: "space-between",
                // alignItems: "center",
                alignItems: "left",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "16px", fontWeight: 600 }}
              >
                Current Pending Requisation
              </span>
            </Col>
            <Col span={7}>
              <span
                style={{
                  display: "flex",
                  justifyContent: "flex-end", // Aligns the content to the right within the flex container

                  color: "#45b6fe",
                  fontSize: "1.8rem", // Corrected to camelCase
                  fontWeight: "400", // Corrected to camelCase
                }}
              >
                {" "}
                {props.data.TotalPendingSaudaValue ?? null}
              </span>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col
        lg={{ span: 11, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            background: "#daebf336",
          }}
          bordered={false}
          className={classes["Card"]}
        >
          <Row>
            <Col
              md={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align items vertically in the center
                // marginTop: "10px",
              }}
            >
              <Link to="/stock/transaction/dailyIssue-create?dailyIssue">
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    cursor: "pointer",
                    marginRight: "8px", // Add some space between the icon and text
                  }}
                  // onClick={() => (window.location.href = "/add-new-contract")}
                />
              </Link>

              <span
                style={{
                  color: "#45b6fe",
                  fontSize: "16px",
                  cursor: "pointer",
                  fontWeight: 600, // Make the text bold
                }}
                // onClick={() => (window.location.href = "/add-new-contract")}
              >
                Add New Issue
              </span>
            </Col>
          </Row>

          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "16px", fontWeight: 600 }}
              >
                Yesterday Issue
              </span>{" "}
              <div className={classes["Rata1"]} style={{ textAlign: "right" }}>
                {props.data.TotalMonthlyOrderValue !== null
                  ? props.data.TotalMonthlyOrderValue
                  : null}{" "}
              </div>
              {/* Data */}
            </Col>
          </Row>

          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "16px", fontWeight: 600 }}
              >
                Today Issue
              </span>{" "}
              {/* Heading */}
              <div
                className={classes["Rata1"]}
                style={{
                  // color: "white", // Keep existing white color for the text
                  padding: "2px", // Add some padding for better appearance
                }}
              >
                {props.data.TotalYearlyOrderValue !== null
                  ? props.data.TotalYearlyOrderValue
                  : null}{" "}
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default DataCards;
